import { DateTime } from 'luxon'

import { digObject } from '@domain-group/javascript-utils'

import {
  Box, Image, ListItem, ListItemWithImage, Text,
} from '@domain-group/suit-theme'

import usePublication from '@hooks/usePublication'
import useSelector from '@hooks/useSelector'

import DeadlinesListItem from './DeadlinesListItem'

type DeadlineProps = {
  publicationId: number,
}

const Deadline = (props: DeadlineProps) => {
  const { publicationId } = props

  const publicationPayload = usePublication({ id: publicationId })

  const { publication } = publicationPayload

  const {
    // @ts-expect-error TS2339
    deadlines, editions, logo, title,
  } = publication

  const imageUrl = digObject(logo, 'thumb', '')

  const publicationEditions = useSelector(reduxState => reduxState.entities.publicationEditions)

  const nextEdition = publicationEditions[editions[0]] || {}
  const publicationDate = digObject(nextEdition, 'publication_date', undefined)

  const formatPublicationDate = publicationDate
    ? DateTime.fromFormat(publicationDate, 'dd/MM/yyyy')
      .toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
    : ''

  return (
    <Box variant="white" marginBottom="large" flexDirection="column">
      <Box alignItems="center">
        <ListItemWithImage
          boxProps={{
            alignItems: 'center',
            border: 'none',
            display: 'flex',
            height: '50px',
            justifyContent: 'center',
            marginBottom: 0,
            width: '100px',
          }}
          imageComponent={imageUrl ? (
            <Image width={100} height={50} url={imageUrl} />
          ) : (
            <Box padding="small" justifyContent="center" textAlign="center" width="100px">
              <Text fontSize="xsmall" variant="ellipsis">
                {title}
              </Text>
            </Box>
          )}
        />

        <ListItem
          boxProps={{
            border: '1px solid',
            borderTop: 0,
            borderRight: 0,
            padding: 'large',
            alignItems: 'center',
          }}
          disableHover
        >
          <Box flexDirection="column" justifyContent="center">
            <Text fontSize="small">{title}</Text>

            <Box alignItems="center" fontSize="small" marginTop="medium">
              <Text color="bodyFontLightColor">
                {formatPublicationDate ? `Next Edition: ${formatPublicationDate}` : 'No upcoming editions'}
              </Text>
            </Box>
          </Box>
        </ListItem>
      </Box>

      {deadlines && (
        <Box borderTop="1px solid" borderColor="lineColor" flexDirection="column" padding="medium">
          <DeadlinesListItem deadlineKey="booking" publication={publication} />
          <DeadlinesListItem deadlineKey="artwork" publication={publication} />
          <DeadlinesListItem deadlineKey="editorial" publication={publication} />
          <DeadlinesListItem deadlineKey="ofi" publication={publication} />
        </Box>
      )}
    </Box>
  )
}

export default Deadline
